var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cbaas-contract-param-table"},[_c('normal-table',{attrs:{"table-data":_vm.list,"table-col":_vm.headList,"show-pagination":false,"use-empty":false,"paging":{ total: _vm.list.length },"show-border":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }